import { useState, useEffect, useMemo, useRef } from 'react';
import { parsePhoneObjToString } from '../utils/utils';
import { Modal, TextField, Button } from '@material-ui/core';
import { shouldBeLocked } from '../utils/Roles'

const PhoneInputRefactor = ({ setPhoneNumber, phoneString = "", personId, modalClass, textFieldClass, inputClass, paperClass, title, propertyName, textFieldStyle, containerStyle = {}, disabled = false, userRoles, ...props }) => {
  const memoizedLocked = useMemo(() => shouldBeLocked(disabled, props?.canEdit, userRoles), [disabled, props?.canEdit, userRoles]);

  const [phoneModal, setPhoneModal] = useState(false)
  const phoneInputRef = useRef(null)
  const focusGuardRef = useRef(false)
  const [parsedPhone, setParsedPhone] = useState({
    areaCode: "",
    prefix: "",
    lineCode: "",
    ext: "",
  })
  useEffect(() => {
    if (phoneString) {
      let ext = phoneString.split('#')[1] || ""
      let phoneNoExtString = phoneString.split('#')[0] || ""
      let phoneParts = phoneNoExtString.split('-')
      setParsedPhone({
        areaCode: phoneParts[0],
        prefix: phoneParts[1],
        lineCode: phoneParts[2],
        ext: ext,
      })
    }
  }, [phoneString])

  const handleLocalPhoneChange = (e) => {
    let name = e.target.name
    let value = e.target.value
    setParsedPhone(prevState => {
      return { ...prevState, [name]: value }
    })
  }

  const sendPhoneUpdate = (e) => {
    e.preventDefault();
    focusGuardRef.current = true
    if (phoneInputRef.current) {
      phoneInputRef.current.blur()
    }
    setPhoneModal(false)
    window.setTimeout(() => {
      focusGuardRef.current = false
    }, 0)
    let phoneNumber = parsePhoneObjToString(parsedPhone)
    setPhoneNumber(phoneNumber, propertyName)
  }

  const cancelPhoneChange = (e) => {
    e.preventDefault()
    focusGuardRef.current = true
    if (phoneInputRef.current) {
      phoneInputRef.current.blur()
    }
    setPhoneModal(false)
    window.setTimeout(() => {
      focusGuardRef.current = false
    }, 0)
    if (phoneString) {
      let ext = phoneString.split('#')[1] || ""
      let phoneNoExtString = phoneString.split('#')[0] || ""
      let phoneParts = phoneNoExtString.split('-')
      setParsedPhone({
        areaCode: phoneParts[0],
        prefix: phoneParts[1],
        lineCode: phoneParts[2],
        ext: ext,
      })
    }
  }

  return (
    <div style={containerStyle}>
      <TextField
        data-cy={"primary-phone-textfield-" + personId}
        inputProps={{ "data-cy": "primary-phone-textfield-input-" + personId }}
        InputLabelProps={{ shrink: true }}
        inputRef={phoneInputRef}
        id={title + personId}
        label={title}
        // value={person?.personalAttribute?.phone || ""}
        value={parsePhoneObjToString(parsedPhone)}
        onClick={() => {
          if (!focusGuardRef.current) {
            setPhoneModal(true)
          }
        }}
        onFocus={() => {
          if (!focusGuardRef.current) {
            setPhoneModal(true)
          }
        }}
        className={textFieldClass}
        style={textFieldStyle}
        disabled={memoizedLocked}
      />
      <Modal
        // disableEnforceFocus
        open={phoneModal}
        onClose={cancelPhoneChange}
        className={modalClass}

      >
        <form className={paperClass} onSubmit={sendPhoneUpdate}>
          {/* eslint-disable-next-line jsx-a11y/no-autofocus -- Focus Area Code when the phone editor opens so typing can begin immediately. */}
          <TextField autoFocus
            id={"area-code-" + personId}
            label="Area Code (XXX)"
            value={parsedPhone?.areaCode || ""}
            name='areaCode'
            onChange={handleLocalPhoneChange}
            // onChange={(e) => console.log(e.target.value)}
            className={inputClass}
            InputLabelProps={{ shrink: true }}
            disabled={memoizedLocked}
          />
          <TextField
            id={"first-three-phone-" + personId}
            label="XXX"
            value={parsedPhone?.prefix || ""}
            name='prefix'
            onChange={handleLocalPhoneChange}
            className={inputClass}
            InputLabelProps={{ shrink: true }}
            disabled={memoizedLocked}
          />
          <TextField
            id={"second-four-phone-" + personId}
            label="XXXX"
            value={parsedPhone?.lineCode || ""}
            name='lineCode'
            onChange={handleLocalPhoneChange}
            className={inputClass}
            InputLabelProps={{ shrink: true }}
            disabled={memoizedLocked}
          />
          <TextField
            id={"phone-extension-" + personId}
            label="Ext."
            value={parsedPhone?.ext || ""}
            name='ext'
            onChange={handleLocalPhoneChange}
            className={inputClass}
            InputLabelProps={{ shrink: true }}
            disabled={memoizedLocked}
          />
          <Button disabled={memoizedLocked} type="submit">Ok</Button>
          <Button onClick={cancelPhoneChange}>Cancel</Button>
        </form>
      </Modal>
    </div>

  );
}

export default PhoneInputRefactor;
